import { useTheme } from 'styled-components';
import { b2bTheme } from '../b2b';
import { defaultDarkTheme } from '../default';
import { olympicDarkTheme } from '../olympic/olympic';
const darkThemeMatches = {
    dark: defaultDarkTheme,
    light: defaultDarkTheme,
    olympicDark: olympicDarkTheme,
    olympicLight: olympicDarkTheme,
    b2b: b2bTheme,
};
export const useDarkTheme = () => {
    const surroundingTheme = useTheme();
    const darkTheme = darkThemeMatches[surroundingTheme.name];
    return darkTheme;
};
//# sourceMappingURL=useDarkTheme.js.map